import './Sectors.css';

const sectors = [
  {
    icon: '🌾',
    title: 'Agriculture Commodities',
    tag: 'Operational',
    desc: 'Decentralized agri-processing with market linkage — from villages to shelves of India\'s leading food businesses. Our foundation and ongoing core.',
  },
  {
    icon: '🍯',
    title: 'Food & Beverage',
    tag: 'Development',
    desc: 'Authentic rural flavours, packaged for the modern consumer — crafted from distinctive regional ingredients you won\'t find on a supermarket shelf.',
  },
  {
    icon: '📦',
    title: 'Consumer Products',
    tag: 'Exploring',
    desc: 'Consumer durable products designed for rural constraints - for the growing rural and peri-urban consumer in a changing world.',
  },
  {
    icon: '💵',
    title: 'Finance',
    tag: 'Exploring',
    desc: 'Inclusive financial products and services designed for the underserved rural economy — from insurance to investments.',
  },
  {
    icon: '🏍️',
    title: 'Sustainable Mobility',
    tag: 'Exploring',
    desc: 'Affordable electric load vehicles built for rural business owners — cleaner, cheaper last-mile logistics for the new-age rural economy.',
  },
  {
    icon: '🎭',
    title: 'Entertainment & Experiences',
    tag: 'Exploring',
    desc: 'Culturally rooted entertainment, tourism, and experience-led businesses that celebrate and sustain rural India\'s rich heritage.',
  },
];

export default function Sectors() {
  return (
    <section className="sectors" id="sectors">
      <div className="sectors-inner">
        <div className="sectors-header">
          <p className="section-label">What We Do</p>
          <h2 className="section-title">Multiple sectors.<br />One thesis.</h2>
          <div className="divider" />
          <p className="section-body">
            We look for business opportunities where rural India has a structural advantage
            for hands-on capital to unlock disproportionate impact.
          </p>
        </div>
        <div className="sectors-grid">
          {sectors.map(s => (
            <div className="sector-card" key={s.title}>
              <div className="sector-icon">{s.icon}</div>
              <div className="sector-tag">{s.tag}</div>
              <h3 className="sector-title">{s.title}</h3>
              <p className="sector-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
